// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autocomplete-field-textfield > div {\n  display: block; }\n\n.autocomplete-field-textfield input {\n  width: auto;\n  display: inline-block; }\n\n.autocomplete-suggestions-wrapper,\n.autocomplete-containing-wrapper {\n  display: block; }\n\n.autocomplete-containing-wrapper {\n  width: 100%; }\n\n.autocomplete-none-multi .autocomplete-field-textfield input {\n  display: block;\n  width: calc(100% - 10px);\n  box-sizing: border-box; }\n", ""]);
// Exports
module.exports = exports;
